import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import requestDataForRooms from '../../../../../actions/bookingCalendar/room/requestDataForRooms'
import { IStore } from '../../../../../reducers'
import { getRooms } from '../../../../../reducers/bookingCalendar/selectors/erhaltenZimmer'
import {
  getIntegrations,
  getLicenses,
  isLicenseLoading,
} from '../../../../../reducers/userAccount/selectors/license'
import { getAirbnbIntegration } from '../../../../../actions/airbnb'

const mapStateToProps = (state: IStore) => {
  const integrations = getIntegrations
  return {
    integrations: integrations(state),
    licenses: getLicenses(state),
    isLoading: isLicenseLoading(state),
    rooms: getRooms(state),
  }
}

const bindDispatchToProps = (dispatch: Dispatch) => ({
  loadRooms: () => {
    dispatch(getAirbnbIntegration())
    dispatch(requestDataForRooms())
  },
})

export default connect(mapStateToProps, bindDispatchToProps)
